<script>
  import AddToCart from "$lib/utils/AddToCartFunction";

  /**@type {import ('$lib/types/index').PublicProduct}*/
  export let product;
  let addToCart = new AddToCart();

  let statusAnimation = "on-hold";

  /**@param {number}ms */
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  /**@ts-ignore*/
  function addToCartAnimation(e) {
    const ANIMATION_DURATION_MS = 200;
    // clone svg button
    // const productCard = e.currentTarget.parentNode.parentNode.parentNode.parentNode
    const productCard = e.currentTarget.closest(".product-card");
    // get shopping bag location
    // @ts-ignore
    const shoppingbag = document.querySelector(".shopping-bag-icon");
    /**@ts-ignore */
    const cartBoundaries = shoppingbag.getBoundingClientRect();
    const buttonBoundaries = productCard.getBoundingClientRect();
    const endX = buttonBoundaries.x;
    const endY = buttonBoundaries.y;
    const startX = cartBoundaries.x;
    const startY = cartBoundaries.y;
    const width = productCard.clientWidth;
    const height = productCard.clientHeight;
    const moveX = endX - startX;
    const moveY = endY - startY;
    const moveD = Math.sqrt(moveX * moveX + moveY * moveY);
    const duration = (ANIMATION_DURATION_MS * moveD) / 642;
    const productCardClone = productCard.cloneNode(true);
    productCardClone.classList.add("add-to-cart-animated-element");
    // start cloned button at start position
    productCardClone.style.setProperty("--start-y_", `${startY}px`);
    productCardClone.style.setProperty("--start-x_", `${startX}px`);
    productCardClone.style.setProperty("--width_", `${width}px`);
    productCardClone.style.setProperty("--height_", `${height}px`);
    productCardClone.style.setProperty("--duration_", `${duration}ms`);
    productCardClone.style.transform = `translate(${moveX}px, ${moveY}px)`;
    const newButtonSvg = document.body.appendChild(productCardClone);
    //Animation end
    newButtonSvg.addEventListener(
      "animationend",
      () => {
        newButtonSvg.parentNode.removeChild(newButtonSvg);
      },
      { once: true }
    );
  }
  /**@type {HTMLButtonElement}*/
  let button;
  //@ts-ignore
  const addToBag = async (e) => {
    try {
      button.disabled = true;
      
      if (statusAnimation === "on-hold") {
        addToCartAnimation(e);
      }
      statusAnimation = "loading";
      await addToCart.addToCartSingle(product);
      statusAnimation = "finish";
      resetState();
      button.disabled = false;
    } catch (error) {
      console.log(error);
    }
  };

  const resetState = async () => {
    await sleep(3000);
    statusAnimation = "on-hold";
  };
</script>

<button
  on:click={(e) => addToBag(e)}
  class:onHold={statusAnimation == "on-hold"}
  class:loading={statusAnimation == "loading"}
  class:finish={statusAnimation == "finish"}
  bind:this={button}
>
  <div class="hold content">
    <!-- <img src="/images/svg/cart.svg" height="15px" width="15px" alt="cart icon" class="cart-icon" /> -->
    <span>ADD TO BAG</span>
  </div>
  <div class="finish content">
    <img src="/images/svg/check.svg" width="16px" height="16px" alt="check icon" />
    <span class="added"> ADDED</span>
  </div>
</button>

<style>
  /* set primary and global properties of styles button */
  button {
    width: 155px;
    height: 40px;
    border: none;
    border-radius: 3rem;
    color: var(--low-pink);
    background-color: var(--pink);
    box-shadow: 0 20px 30px -7px rgba(27, 27, 27, 0.1);
    transition: all 300ms ease-in-out;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    transition: all 500ms ease;
  }
  button .content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    transition: all 750ms ease;
    z-index: -5;
  }
  button span {
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 1;
  }
  button .cart-icon {
    width: 18px;
    height: 15px;
    object-fit: contain;
    object-position: center;
  }
  button.onHold .hold {
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  button.loading .hold {
    top: -50%;
    transform: translate(-50%, -100%);
    z-index: -5;
  }
  button.loading::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 37%);
    transition: all 300ms ease;
    transform-style: preserve-3d;
    transform-origin: center;
    opacity: 1;
    animation: delete 1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
  }
  @keyframes delete {
    0%,
    50% {
      opacity: 0;
      transform: translateX(-50%) scale(2);
    }
    100% {
      opacity: 1;
      transform: translateX(50%) scale(1);
    }
  }
  button.finish > .finish {
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  button.finish > .finish img,
  button.onHold > .finish {
    width: 16px;
    height: 16px;
  }
  button.onHold > .finish {
    top: -50%;
    transform: translate(-50%, -100%);
    z-index: -5;
  }

  :global(.add-to-cart-animated-element) {
    background-color: #fff;
    position: fixed !important;
    top: var(--start-y_);
    left: var(--start-x_);
    width: var(--width_) !important;
    height: var(--height_) !important;
    z-index: 50;
    animation-name: movetocart;
    animation-duration: var(--duration_);
    animation-timing-function: ease-out;
    transform-origin: top left;
  }

  /*KEYFRAMES FOR THE ANIMATIONS */
  @keyframes movetocart {
    0% {
      opacity: 0.2;
    }
    100% {
      opacity: 0;
      transform: translate(0, 0) scale(0.1);
    }
  }
  @media (max-width: 768px) {
    .cart-icon {
      display: none;
    }
  }
</style>